import { MessageTypeEnum } from 'api/MessagesApi';
import AiCreationGenerating from 'components/Message/CreateMessageComponent/StepMessage/AiCreation//AiCreationGenerating/AiCreationGenerating';
import AiCreationClosing from 'components/Message/CreateMessageComponent/StepMessage/AiCreation/AiCreationClosing/AiCreationClosing';
import AiCreationFocus from 'components/Message/CreateMessageComponent/StepMessage/AiCreation/AiCreationFocus/AiCreationFocus';
import AiCreationMemory from 'components/Message/CreateMessageComponent/StepMessage/AiCreation/AiCreationMemory/AiCreationMemory';
import AiCreationTone from 'components/Message/CreateMessageComponent/StepMessage/AiCreation/AiCreationTone/AiCreationTone';
import ManualCreation from 'components/Message/CreateMessageComponent/StepMessage/ManualCreation/ManualCreation';
import { useMessageService } from 'components/Message/useMessageService';
import { useState } from 'react';

const enum AiCreationStepsEnum {
  Tone,
  Focus,
  Memory,
  Closing,
  Generating,
  Manual
}

type AllProps = {
  initContent?: string;
  onNext: (shouldExit?: boolean) => void;
  onBack: () => void;
  goToDeliveryInfo: () => void;
};

function AiCreation({ initContent, onNext, onBack, goToDeliveryInfo }: AllProps) {
  const { message } = useMessageService();

  const [draftTitle, setDraftTitle] = useState<string>('');
  const [draftText, setDraftText] = useState<string>('');
  const [tones, setTones] = useState<string[]>([]);
  const [emotionFocus, setEmotionFocus] = useState<string>();
  const [memory, setMemory] = useState<string>();
  const [closing, setClosing] = useState<string>();
  const [otherInfo, setOtherInfo] = useState<string>();

  const [currentStep, setCurrentStep] = useState(
    message?.fileName || (message?.type === MessageTypeEnum.Text && message?.content)
      ? AiCreationStepsEnum.Generating
      : AiCreationStepsEnum.Tone
  );

  return (
    <>
      {currentStep === AiCreationStepsEnum.Tone ? (
        <AiCreationTone
          onBack={onBack}
          onSave={(tones, shouldExit) => {
            setTones(tones);
            if (shouldExit) {
              onNext(shouldExit);
            } else {
              setCurrentStep(AiCreationStepsEnum.Focus);
            }
          }}
        />
      ) : currentStep === AiCreationStepsEnum.Focus ? (
        <AiCreationFocus
          tones={tones}
          onBack={() => {
            setCurrentStep(AiCreationStepsEnum.Tone);
          }}
          onSave={(emotionFocus, shouldExit) => {
            setEmotionFocus(emotionFocus);
            if (shouldExit) {
              onNext(shouldExit);
            } else {
              setCurrentStep(AiCreationStepsEnum.Memory);
            }
          }}
        />
      ) : currentStep === AiCreationStepsEnum.Memory ? (
        <AiCreationMemory
          tones={tones}
          onBack={() => {
            setCurrentStep(AiCreationStepsEnum.Focus);
          }}
          onSave={(memory, shouldExit) => {
            setMemory(memory);
            if (shouldExit) {
              onNext(shouldExit);
            } else {
              setCurrentStep(AiCreationStepsEnum.Closing);
            }
          }}
        />
      ) : currentStep === AiCreationStepsEnum.Closing ? (
        <AiCreationClosing
          tones={tones}
          onBack={() => {
            setCurrentStep(AiCreationStepsEnum.Memory);
          }}
          onSave={(closing, otherInfo, shouldExit) => {
            setClosing(closing);
            setOtherInfo(otherInfo);
            setDraftText('');
            setDraftTitle('');

            if (shouldExit) {
              onNext(shouldExit);
            } else {
              setCurrentStep(AiCreationStepsEnum.Generating);
            }
          }}
        />
      ) : currentStep === AiCreationStepsEnum.Generating ? (
        <AiCreationGenerating
          initTitle={draftTitle}
          initContent={draftText}
          tones={tones}
          emotionFocus={emotionFocus}
          memory={memory}
          closing={closing}
          otherInfo={otherInfo}
          onBack={() => {
            setCurrentStep(AiCreationStepsEnum.Closing);
          }}
          onSave={(text, title) => {
            setDraftText(text);
            setDraftTitle(title);

            setCurrentStep(AiCreationStepsEnum.Manual);
          }}
        />
      ) : currentStep === AiCreationStepsEnum.Manual ? (
        <ManualCreation
          initContent={draftText}
          initTitle={draftTitle}
          onBack={() => {
            setCurrentStep(AiCreationStepsEnum.Generating);
          }}
          onNext={onNext}
          goToDeliveryInfo={goToDeliveryInfo}
        />
      ) : null}
    </>
  );
}

export default AiCreation;
